import React from "react";
import { Helmet } from "react-helmet";
import "../styles/music.css";
import $ from "jquery";

function next() {
  $(window).scrollTop(0);
  $(".current")
    .removeClass("current")
    .hide()
    .next()
    .css("display", "flex")
    .addClass("current");

  if ($(".current").hasClass("last")) {
    $("#next").css("display", "none");
  }
  $("#prev").css("display", "block");
}

function previous() {
  $(window).scrollTop(0);
  $(".current")
    .removeClass("current")
    .hide()
    .prev()
    .css("display", "flex")
    .addClass("current");

  if ($(".current").hasClass("first")) {
    $("#prev").css("display", "none");
  }
  $("#next").css("display", "block");
}

const Music = () => {
  return (
    <div>
      <Helmet>
        <title>GAUSH - MUSIC</title>
      </Helmet>
      <section className="music-catalog">
        <p
          style={{
            fontSize: "50px",
            color: "#FFFFFF",
            lineHeight: "90%",
            marginBottom: "60px",
          }}
        >
          MUSIC CATALOG
        </p>
        <div className="spotify-blocks">
          <div id="div1" className="first current spotify-frames">
            <iframe
              src="https://open.spotify.com/embed/track/3QP9yuBbDgy9tmTeG6aIaz"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/7ljpQ6YCt1Mqzt85RNuiab"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/5KMbelIhlPgZZzd2WhObgE"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/0uARnIZRkbBJ69edvIjhMu"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/4HtSwM8VJIfn8cD815vqak"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/4dKfhIpkYyXUgmNDFSLR7j"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/148eadI7MAokqCZgUioTjG"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/2ONWsRVoNEcYxEf0JTW1G2"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/0lJ7e1N22gBceDGQBwBX9V"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/6zgcE1OKi07akituXbl6u7"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
          </div>
          <div id="div2" className="spotify-frames">
            <iframe
              src="https://open.spotify.com/embed/track/2twFWERGaiXPsgGDvKSMoD"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/4IgZ9XMvYVbJKvZZ1Jshwa"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/2ZqJmsnVw4wgVgdJWWmc5j"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/6kofRRCcoXNJsyCn0jX2DV"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/1AvIQDjqKGXQqM1pKeVxlV"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/4REVh1CwPq3VrQhhyMb3ZE"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/3sE9ZkbdMKxp2qXhg47tFe"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/5vXsKknHF5g8ttZZzixGRz"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/28iufZWoRDB50Y2PVX1pdL"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/1iVVk9yJadYvnK2ASxqs6c"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
          </div>
          <div id="div3" className="last spotify-frames">
            <iframe
              src="https://open.spotify.com/embed/track/05bJT2fv8tTBgRPzYU46Vz"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/0TSQ6q4cuTzQVBKLjTav3I"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/4GqKdfeopjigfU9e1HwKkH"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/4RkzWEH8hYHNb7pYdC9xDk"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/6Lb5raMMfZvrimuiESHQQk"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/6G6afvYU9vxLaM6F1mRtH4"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/2dV49ImFMzL9TEQT9rmr4D"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/3fjasTvEScQXmBm4aXKYEw"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
            <iframe
              src="https://open.spotify.com/embed/track/3215aSwJz257Sr6uZuMsV8"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
          </div>
        </div>
        <div className="navigation-btn">
          <img onClick={previous} src="/images/previous.svg" id="prev" />
          <img onClick={next} src="/images/next.svg" id="next" />
        </div>
      </section>
    </div>
  );
};

export default Music;
